import { combine } from 'zustand/middleware';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

export type SortDirection = 'asc' | 'desc' | 'default';

export type SortType = 'expire-time' | 'volume';

export type Category = 'trending' | 'new' | 'live' | 'watchlist' | string;

export const useHomeStore = createWithEqualityFn(
  combine(
    {
      tag: '',
      category: 'trending' as Category,
      sortType: '' as SortType,
      sortDirection: 'default' as SortDirection,
    },
    set => ({
      setTag: (tag: string) => set({ tag }),
      setCategory: (category: Category) => set({ category }),
      setSortType: (sortType: SortType) => set({ sortType }),
      setSortDirection: (sortDirection: SortDirection) => set({ sortDirection }),
    })
  ),
  shallow
);
